<template>
    <v-row>
        <v-col :class="tab && 'px-0 pt-0'">
            <slot></slot>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: "Row", 
    props: {
        tab: Boolean
    }
}

</script>